import i18n from "@/i18n"
import React, { useState } from "react"
import styled from "styled-components"
import { useSelector } from 'react-redux';
import { Trans } from "react-i18next";

const MainContainer = styled.main`
    position: relative;
    align-self: stretch;
    display: flex;
    width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    justify-content: end;
    padding: 175px 0 70px 0;
    background-color: black;
    z-index: 0;
`

const VideoWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    opacity: 0.4;
`

const Video = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const Thumbnail = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`


const ContentWrapper = styled.section`
    display: flex;
    width: 1060px;
    max-width: 100%;
    flex-direction: column;
    align-items: start;
`

const HeaderSection = styled.header`
    display: flex;
    flex-direction: column;
    z-index: 1;
`

const MainTitle = styled.h1`
    color: #fff;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -1px;
    font-weight: 900;
    text-align: left;
	white-space: pre-wrap;
    margin: 10px 0;

    >.highlight {
        color: #83c308;
    }
`

const BannerWrapper = styled.div`
    display: flex;
    margin-top: 12px;
    align-items: center;
    gap: 4px;
    line-height: 1;
`

const LogoContainer = styled.div`
    align-self: stretch;
    display: flex;
    align-items: start;
    color: #83c308;
    margin: auto 10px auto 0;

	&.en {
		width: 386px;
	}

	&.jp {
		width: 424px;
	}
`

const LogoBadge = styled.div`
    border-radius: 999px;
    background-color: #222;
    position: relative;
    display: flex;
    min-height: 52px;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
`

const LogoText = styled.span`
    font-size: 34px;
    letter-spacing: -0.68px;
    z-index: 0;
    strong {
        color: #83c308;
        &.highlight {
            padding-right: 6px;
            color: #83c308;
        }
    }
`

const PlusIcon = styled.span`
    font-size: 20px;
    letter-spacing: -0.4px;
    color: #83c308;
    position: absolute;
    z-index: 0;
    right: 15px;
    top: 4px;
`

const LaunchText = styled.span`
    padding-left: 4px;
    color: #fff;
    font-size: 38px;
    font-weight: 700;
    letter-spacing: -0.76px;
    align-self: stretch;
    margin: auto 0;
`

const FeatureText = styled.p`
    color: #e0e0e0;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.48px;
	white-space: pre-wrap;
    line-height: 26px;
    text-align: left;
    z-index: 1;
`;

const NoteText = styled.p`
    border-radius: 8px;
    margin-top: 14px;
    font-size: 14px;
    color: #D4D4D4;
    font-weight: 500;
    letter-spacing: -0.28px;
    
    line-height: 1;
    z-index: 1;
`

function LaunchBanner() {
	const lang = useSelector(state => state.langStore.lang);
    return (
        <BannerWrapper>
            <LogoContainer className={lang}>
                <LogoBadge>
                    <LogoText>
                        <strong>COMING SOON</strong>
                        {/* <strong className="highlight">{i18n.t("common.landing.top.banner.videomonster")}</strong>
                        <strong>{i18n.t("common.landing.top.banner.plus")}</strong> */}
                    </LogoText>
                    {/* <PlusIcon>+</PlusIcon> */}
                </LogoBadge>
            </LogoContainer>
            {/* <LaunchText>{i18n.t("common.landing.top.banner.launching")}</LaunchText> */}
        </BannerWrapper>
    );
}

function GenerationNote() {
    return (
        <NoteText>
            본 이미지는 비디오몬스터 플러스로 생성되었습니다
        </NoteText>
    )
}

function AIFeatureText() {
    return (
        <FeatureText>
            {i18n.t("common.landing.top.banner.text.new")}
        </FeatureText>
    )
}

function ThumbnailVideo() {
    const [isLoaded, setIsLoaded] = useState(false)

    return (
        <VideoWrapper>
            <Video
                src={"https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/1_banner_pc_v4.mp4"}
                muted
                autoPlay
                loop
                playsInline
                webkit-playsinline
                onLoadedData={() => setIsLoaded(true)}
            />
            <Thumbnail
                style={{
                    display: isLoaded ? "none" : "block"
                }}
                src={"https://front.videomonster.com/videos-u6yd72dy/landing/1_banner_pc_v4.jpg"}
            />
        </VideoWrapper>
    )
}

export default function TopBannerSection(props) {
    return (
        <MainContainer>
            <ThumbnailVideo />
            <ContentWrapper>
                <HeaderSection>
                    <LaunchBanner />
                    <MainTitle>
						<Trans i18nKey="common.landing.top.banner.title.new" components={[<span className="highlight" />]} />
                    </MainTitle>
                </HeaderSection>
                <AIFeatureText />
                {/* <GenerationNote /> */}
            </ContentWrapper>
        </MainContainer>
    )
}